/* global videojs */
		
videojs.closeButton = videojs.Button.extend({
	/* @constructor */
	init: function(player, options) {
	videojs.Button.call(this, player, options);
	this.on("click", this.onClick);
	}
});

/* This function is called when button is clicked */
videojs.closeButton.prototype.onClick = function() {
  $(document).trigger("closingEvent", {sender: "videojs-closebutton.js", detail: "ending"});
};
	
/* Create Close button */
var createCloseButton = function() {
	var props = {
		className: "vjs-close-button",
		innerHTML: '<span class="fa-stack"><i class="fa fa-circle fa-stack-2x"></i><i class="fa fa-close fa-stack-1x fa-inverse"></i></span>', 
		role: "button",
		"aria-live": "polite",
		tabIndex: 0
	};

	return videojs.Component.prototype.createEl(null, props);
};
	
/* Add close button to the control bar */
var closeButton;
videojs.plugin("closeButton", function() {
	var options = { "el" : createCloseButton() };
	closeButton = new videojs.closeButton(this, options);
	this.el().appendChild(closeButton.el());
});


